import React from "react";
import { SiboForm } from "./form/index";

export default SiboForm;
